import { createAction } from 'redux-actions';
import actionTypes from './types';

export const getSalaryIncreaseAverage = createAction(
  actionTypes.BENCHMARKING_SALARY_INCREASE_AVERAGE
);

export default getSalaryIncreaseAverage;
